import React, { Component } from 'react';
import { connect } from 'react-redux';

import ErrorBoundary from './components/ErrorBoundary';
import Loader from './ui/Loader';

class App extends Component {
  render() {
    const { loader } = this.props;
    return (
      <ErrorBoundary>
        {this.props.children}
        {loader.show && <Loader />}
      </ErrorBoundary>
    );
  }
}

const mapStateToProps = state => ({
  loader: state.loader
});

export default connect(mapStateToProps, null)(App);



// WEBPACK FOOTER //
// ./src/App.js